export enum GetPanelAdsErrors {
  InternalError = 50,
}

export const GetPanelAdsErrorMessages = {
  [GetPanelAdsErrors.InternalError]: "InternalError",
};

export enum GetAdReportErrors {
  InternalError = 50,
}

export const GetAdReportErrorMessages = {
  [GetAdReportErrors.InternalError]: "InternalError",
};

export enum GetCampaignAdsErrors {
  InternalError = 50,
}

export const GetCampaignAdsErrorMessages = {
  [GetCampaignAdsErrors.InternalError]: "InternalError",
};

export enum ChangeCampaignStateErrors {
  InternalError = 50,
}

export const ChangeCampaignStateErrorMessages = {
  [ChangeCampaignStateErrors.InternalError]: "InternalError",
};
